// extracted by mini-css-extract-plugin
export var deliveryRow = "_o9-a";
export var fixedHeight = "_o9-4";
export var freightLogo = "_o9-9";
export var fullWidth = "_o9-3";
export var priceColumn = "_o9-5";
export var radioSelected = "_o9-7";
export var radioUnselected = "_o9-6";
export var selectedOption = "_o9-2";
export var selectedOptionContainer = "_o9-1";
export var selection = "_o9-0";
export var tallSkeletonText = "_o9-8";